module.exports = __webpack_public_path__ + "static/img/3.e4a848e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/zh/3.png
// module id = ZkM0
// module chunks = 0